import React, { useState, useEffect, useContext } from "react";

import {
  Grid,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
} from "@material-ui/core";

import {
  MonetizationOn,
  ListAlt,
  PeopleAlt,
  CheckCircle,
  ArrowForward,
  ArrowBack,
} from "@material-ui/icons";

import { WizardVenda, FontButton } from "../styles/Emissao";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import clsx from "clsx";

import { EmissaoContext } from "../contexts/EmissaoContext";
import Btn from "../../../../components/buttons/Btn";

import useWizardEmissaoController from "../controllers/WizardEmissaoController";

import "moment/locale/pt-br";

import WizardStepsPurchaseTaxNote from "./WizardStepsPurchaseTaxNote";

const WizardEmissaoCompra = ({
  setOpenWizardCompra,
  setOpenModal,
  demandOptions = {},
}) => {
  const { setTypeMontage } = useContext(EmissaoContext);

  const { handleNextNfePurchase, handleBackPurchase } =
    useWizardEmissaoController();

  const [activeStep, setActiveStep] = useState(0);

  const montageTypeOptions = {
    isMontageByDevolution: demandOptions.tipo[0] === "D",
    steps: demandOptions.steps || [],
  };

  useEffect(() => {
    setTypeMontage(demandOptions.tipo[0]);
  }, [demandOptions.tipo, setTypeMontage]);

  const ColorlibConnector = withStyles({
    alternativeLabel: {
      top: 22,
    },
    active: {
      "& $line": {
        backgroundImage:
          "linear-gradient( 136deg, rgb(12, 45, 106) 0%, rgb(214, 229, 255) 50%)",
      },
    },
    completed: {
      "& $line": {
        backgroundImage:
          "linear-gradient( 136deg, rgb(12, 45, 106) 0%, rgb(214, 229, 255) 50%)",
      },
    },
    line: {
      height: 3,
      border: 0,
      backgroundColor: "#eaeaf0",
      borderRadius: 1,
    },
  })(StepConnector);

  const useColorlibStepIconStyles = makeStyles({
    root: {
      backgroundColor: "#ccc",
      zIndex: 1,
      color: "#fff",
      width: 50,
      height: 50,
      display: "flex",
      borderRadius: "50%",
      justifyContent: "center",
      alignItems: "center",
    },
    active: {
      backgroundImage:
        "linear-gradient( 136deg, rgb(12, 45, 106) 0%, rgb(214, 229, 255) 50%, rgb(188, 220, 207) 100%)",
      boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
    },
    completed: {
      backgroundImage:
        "linear-gradient( 136deg, rgb(12, 45, 106) 0%, rgb(214, 229, 255) 50%, rgb(188, 220, 207) 100%)",
    },
  });

  function ColorlibStepIcon(props) {
    const classes = useColorlibStepIconStyles();
    const { active, completed } = props;

    const icons = {
      1: <PeopleAlt />,
      2: <MonetizationOn />,
      3: <ListAlt />,
    };

    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
          [classes.completed]: completed,
        })}
      >
        {icons[String(props.icon)]}
      </div>
    );
  }

  return (
    <>
      <Stepper
        alternativeLabel
        activeStep={activeStep}
        connector={<ColorlibConnector />}
      >
        {montageTypeOptions.steps.map((label) => (
          <Step key={label}>
            <StepLabel StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <WizardVenda>
        <WizardStepsPurchaseTaxNote step={activeStep} />
      </WizardVenda>
      <FontButton>
        <Grid container spacing={1}>
          <Grid item sm={activeStep !== 4 ? 8 : 10}></Grid>
          <Grid item sm>
            <Btn
              startIcon={<ArrowBack />}
              disabled={activeStep === 0}
              onClick={() => {
                handleBackPurchase({
                  setActiveStep,
                });
              }}
              label="voltar"
              full="true"
            />
          </Grid>
          {activeStep !== 4 && (
            <Grid item sm>
              <Btn
                full="true"
                onClick={() => {
                  handleNextNfePurchase({
                    setActiveStep,
                    activeStep,
                    setOpenModal,
                    setOpenWizardCompra,
                  });
                }}
                endIcon={
                  activeStep === montageTypeOptions.steps.length - 1 ? (
                    <CheckCircle />
                  ) : (
                    <ArrowForward />
                  )
                }
                label={
                  activeStep === montageTypeOptions.steps.length - 1
                    ? "Finalizar"
                    : "Próximo"
                }
              />
            </Grid>
          )}
        </Grid>
      </FontButton>
    </>
  );
};

export default WizardEmissaoCompra;
